module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(!_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n      Payment successful, thank you\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card text-center col-md-offset-3 col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "margin-left": "5px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.subscriptionDto.InvoiceNumber))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "margin-left": "5px"
    }
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.subscriptionDto.TotalAmount))])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "margin-left": "5px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.paymentDateComp))])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.subscriptionDto.Description))]), _vm._v(" valid until\n        "), _c('strong', [_vm._v(_vm._s(_vm.endDateComp))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-3",
    staticStyle: {
      "margin-top": "0px",
      "padding": "0px"
    }
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n        Details will be sent shortly to\n        "), _c('strong', [_vm._v(_vm._s(_vm.subscriptionDto.Email))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-3",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("\n        Go home\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(4)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-check-circle-o",
    staticStyle: {
      "color": "#77c778"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "margin-right": "5px"
    }
  }, [_vm._v("\n          Invoice No:\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "margin-right": "5px"
    }
  }, [_vm._v("\n          Total Amount:\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "margin-right": "5px"
    }
  }, [_vm._v("\n          Payment Date:\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa05f422!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/Success.vue
// module id = 653
// module chunks = 2